/**
 * 提成分销 列表
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 */
import React from 'react';
import { Spin, } from "antd";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@components/Lang/Lang";
import AutoFetchTable from "@components/AutoFetchTable/AutoFetchTable";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import SearchForm from '@components/SearchForm/SearchForm';
import { toFixedWithCommas,} from "@utils/number-util";
import { isEmptyObject,isEmpty,symbolMoneyUtil} from '@utils/utils';
import ExportAsyncBtn from '@components/ExportAsync/ExportAsyncBtn';
import dayjs from "dayjs";
import "./List.less";
class DistributorList extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            initialSearch:{
                status:'VALID', // 启用中	VALID,已停用	INVALID,未启用	NOT_ENABLED
            }, //默认搜索
            searchFormOptions:[
                // {
                //     name:'saleMarketId',
                //     cnTitle:'销售区域',
                //     cnTitleId:'XiaoShouQuYu',
                //     cnPlaceholder:'销售区域',
                //     cnPlaceholderId:'XiaoShouQuYu',
                //     showSubTitle:Lang({id:"GuoJia",default:'国家'}),
                //     type:'Region',
                //     col:24,
                // },
                {
                    name:'status',
                    cnTitle:'账户状态',
                    cnTitleId:'ZhangHuZhuangTai',
                    cnPlaceholder:'账户状态',
                    cnPlaceholderId:'ZhangHuZhuangTai',
                    type:'Enum',
                    enumCanAll:true,
                    enumClass:'fx_user_status',
                    width: 250,
                },
                {
                    name:'distributor',
                    cnTitle:'分销商',
                    cnTitleId:'FenXiaoShang',
                    cnPlaceholder:'分销商名称/账号',
                    cnPlaceholderId:'FenXiaoShangMingChengZhangHao',
                    width: 250,
                },
                // {
                //     name:'inviter',
                //     cnTitle:'推荐人',
                //     cnTitleId:'TuiJianRen',
                //     cnPlaceholder:'推荐人',
                //     cnPlaceholderId:'TuiJianRen',
                //     col:12,
                // },
            ],
            columns:[
                {
                    cnTitle: '分销商',
                    dataIndex: 'name',
                    width:200,
                    cnTitleId: 'FenXiaoShang',
                    render: (name, record) => {
                        const iconUrl = require('../../../assets/img/country/'+record.abbreviate + '.png');
                        return(<>
                            <div className={"flex-item-ver-center"}>
                                <img className={"countryImg"} src={iconUrl?iconUrl.default:''} width={18} />
                                <div className={"black89 fw_700 ml_4"}>{record.accountName}</div>
                            </div>
                            <div className={'mt_4 black45'}>{name}</div>
                        </>)}
                },
                {
                    cnTitle: '推广客户数',
                    cnTitleId: 'TuiGuangKeHuShu',
                    dataIndex: 'buyerCount',
                },
                // {
                //     cnTitle: '下级分销商',
                //     cnTitleId: 'XiaJiFenXiaoShang',
                //     dataIndex: 'twoLevelUserCount',
                //     render: (num, record) => {
                //         return(<div>
                //                 {/*下级分销商用户数 */}
                //                 <p>{num}</p>
                //                 {/* 下级分销商推广客户数 */}
                //             <p className={"flex-item-ver-center"}><IconFont type={'icon-yonghu'} className={"font-16 color-light-grey"} /><span  className={"color-grey margin-left-5"}>{record.twoLevelUserBuyerCount}</span></p>
                //         </div>)}
                // },
                {
                    cnTitle: '客户下单',
                    cnTitleId: 'KeHuXiaDan',
                    dataIndex: 'buyerOrder',
                    type:"money",
                    showSymbol: 'currencySymbol',
                },
                {
                    cnTitle: '累计提成',
                    cnTitleId: 'LeiJiTiCheng',
                    dataIndex: 'commissionPrice',
                    render: (commissionPrice, record) => {
                        return(<div className={"fw_700"}>
                            {symbolMoneyUtil(commissionPrice,record.currencySymbol)}
                        </div>)}
                },

                {
                    cnTitle: '类型&状态',
                    cnTitleId: 'LeiXingZhuangTai',
                    dataIndex: 'status',//todo
                    render: (status, record) => {
                        let sType = ''
                        const types = __getDictMap('fx_user_type')||{};
                        if(!isEmptyObject(types)){
                            sType = !isEmpty(record.type)?types[record.type]:'';
                        }
                        return(<div className={"flex-item-ver-center"}>
                            {/* 分销商状态 fx_user_status :未激活NOT_ENABLED：灰色  |  启用VALID：绿色  |  停用INVALID：红色*/}
                            {status=='VALID'&&<span className={"ri-shield-check-fill mr_4 color-green font_20"} />}
                            {status=='INVALID'&&<span className={"ri-user-forbid-line mr_4 color-red2 font_20"} />}
                            {status=='NOT_ENABLED'&&<span className={"ri-shield-check-fill mr_4 black45 font_20"} />}
                            {/* 分销商类型 */}
                            {sType}
                        </div>)}
                },
                {
                    cnTitle: '有效期至',
                    cnTitleId: 'YouXiaoQiZhi',
                    dataIndex: 'effectiveEndTime',
                    render: (effectiveEndTime, record) => {
                        return(<div>
                            { record.effectiveEndTime?(dayjs(record.effectiveEndTime).format('YYYY-MM-DD')):'-'}
                        </div>)}
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 200,
                    cnTitleId: 'CaoZuo',
                    align:"right",
                    render: (item = {}, record) => (<div className={"flex-item"} style={{justifyContent:"flex-end"}}>
                        <AuthBtn icon={"ri-edit-line"} tips = {Lang({id:"BianJi",default:"编辑"})}
                                 linkTo={{
                                     pathname: '/distributor/edit',
                                     search: `?id=${record.id}&typefrom=orderCommission`,
                                 }}/>
                        <AuthBtn icon={"ri-organization-chart"}
                                 className={"ml_8"}
                                 tips = {Lang({id:"TuiGuangXiangQing",default:"推广详情"})}
                                 linkTo={{
                                       pathname: '/distributor/detail',
                                       search: `?id=${record.id}&typefrom=orderCommission`,
                                   }} />
                        {record.commissionPrice>0?<ExportAsyncBtn postParam={{
                                            code:"fxLastMonthCommissionReport",
                                            conditionVO:{
                                                fxUserId:record.id
                                            }
                                        }}
                                        text={<AuthBtn icon={"ri-file-excel-2-line"} className={"ml_8"} tips = {Lang({id:"XiaZaiYongJinBaoGao",default:"下载佣金报告"})} />}
                        />:<AuthBtn icon={"ri-file-excel-2-line"} className={"ml_8"} tips = {Lang({id:"ZanWuShuJu",default:"暂无数据"})} />}
                    </div>)},
            ],
            selectOption:[
                {   id:1,
                    cnTitle: '按创建时间倒序',
                    cnTitleId: 'AnChangJianShiJianDaoXu',
                    orderDirect:0,// 排序 0是desc,1是asc
                    orderCode:'createTime',
                },
                {   id:2,
                    cnTitle: '按推广客户数倒序',
                    cnTitleId: 'AnTuiGuangKeHuShuDaoXu',
                    orderDirect:0,// 排序 0是desc,1是asc
                    orderCode:'buyerCount',
                },
                {   id:3,
                    cnTitle: '按推广客户数顺序',
                    cnTitleId: 'AnTuiGuangKeHuShuShunXu',
                    orderDirect:1,// 排序 0是desc,1是asc
                    orderCode:'buyerCount',
                },
                {   id:4,
                    cnTitle: '按下级分销商用户数倒序',
                    cnTitleId: 'AnXiaJiFenXiaoShangDaoXu',
                    orderDirect:0,// 排序 0是desc,1是asc
                    orderCode:'twoLevelUserCount',
                },
                {   id:5,
                    cnTitle: '按累积佣金倒序',
                    cnTitleId: 'AnLeiJiYongJinDaoXu',
                    orderDirect:0,// 排序 0是desc,1是asc
                    orderCode:'commissionTotal',
                },
                {   id:6,
                    cnTitle: '按累积佣金顺序',
                    cnTitleId: 'AnLeiJiYongJinShunXu',
                    orderDirect:1,// 排序 0是desc,1是asc
                    orderCode:'commissionTotal',
                },
            ],
            curSelect:{},//当前选择排序
            totalTrucking:{}, //返回的统计
        }
    }
    fetchCallBack(res){
        const {success,valid,model} = res;
        if (success && valid) {
            this.setState({
                totalTrucking:model||{}
            })
        }else this.setState({
            totalTrucking: {}
        })
    }

    /**
     * 勾选 筛选
     * */
    // onChangeSelect(value,selectOption){
    //     let curSelect={}
    //     if(value){
    //         curSelect = selectOption.find(item=>item.id==value)
    //     }else curSelect = selectOption[0];
    //     this.setState({
    //         curSelect:curSelect
    //     },()=> {
    //         this.onPageTemplateTableChild.handleFetch(1,{},true);
    //     })
    // }
    /**
     * 搜索表格 搜索
     ***/
    getFormData(data={}) {
        this.onPageTemplateTableChild.handleFetch(1,data);
    }
    searchReset(){
        this.setState({
            selectSeven: false
        },()=>this.onPageTemplateTableChild.handleFetch(1,{},false))
    }
    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    goPage(sUrl) {
        this.props.history.push(sUrl);
    }
    render(){
        const { loading,searchFormOptions,columns,selectOption,totalTrucking,initialSearch} = this.state;
        let { curSelect} = this.state;
        const currPageName = Lang({id: "TiChengFenXiaoShang",default: "提成分销商"});
        if(isEmptyObject(curSelect))curSelect=selectOption[0];
        return (<Spin tip='loading' spinning={loading}>
                    <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
                    <div className={'distributorListWrap'}>
                        <div className={'flex-item-ver-center black89'}>
                            <span className={"font_18 fw_700"}>{currPageName}</span>
                            <span className={"ml_8 flex-item-ver-center btn-blue"} onClick={()=>this.goPage('/distributor/add?typefrom=orderCommission')} title={Lang({id:'XinZengFenXiaoShang',default:'新增分销商'})}>
                                {Lang({id:'XinZengFenXiaoShang',default:'新增分销商'})}
                            </span>
                        </div>
                        <div className={"black45 font-12"}>{Lang({id: "ZongJi",default: "总计"})}
                            <span>{Lang({id: "FenXiaoShang",default: "分销商"})}</span>{totalTrucking.fxDistributorUserTotal||0}
                            <span>，{Lang({id: "YaoQingKeHu",default: "邀请客户"})}</span>{totalTrucking.invitationBuyerTotal||0}
                            <span>，{Lang({id: "YouXiaoKeHu",default: "有效客户"})}</span>{totalTrucking.authBuyerTotal||0}
                        </div>
                        {searchFormOptions.length>0&&<div className={'top-search'}>
                            <SearchForm
                                options = {searchFormOptions}
                                searchReset={(dat)=>this.searchReset(dat)}
                                pageSize={50}
                                flagShowReset={true}
                                flagShowSearchBtn={true}
                                initialValues={initialSearch}
                                getSearchValue={this.getFormData.bind(this)} />
                        </div>}
                    </div>
                    <div className={'mt_6'}>
                        <AutoFetchTable columns={columns}
                                        onRef={this.onRefTabOne}
                                        flagShowReset={false}
                                        flagShowSearchBtn={false}
                                        pageSize={50}
                                        precondition={{...initialSearch,
                                            type:'1', // 注册提成0, 订单提成1
                                            orderDirect:curSelect.orderDirect, //排序 0是desc,1是asc
                                            orderCode:curSelect.orderCode, // 排序字段  createTime:创建时间 ; buyerCount:推广客户数 ; twoLevelUserCount:下级分销商用户数; commissionTotal:累积佣金
                                        }}
                                        fetchCallBack={(res)=>this.fetchCallBack(res)}
                                        showQuickJumper={false}
                                        fetchApi={'/service/mg/distributor/list'} />
                    </div>
            </Spin>

        )
    }
}

export default DistributorList;
